import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-width: 0;
`;

export const PickerContainer = styled.div`
  padding: 10px;
  flex-shrink: 0;
`;
